/* eslint-env browser */
import React, {
  FC, useEffect, useState, useRef, memo,
} from 'react';
import { setCopyToClipboard } from '@aarhus-university/au-designsystem-delphinus/source/js/components/nav';
import { useLangContext, useUserContext } from '@aarhus-university/au-lib-react-components/src/lib/context';
import { useTranslationsContext } from '../../lib/translation';

const getOppositeLangUri = (): string => {
  const uri = window.location.href;
  if (uri.includes('/en')) {
    return uri.replace('/en', '').replace(window.location.search, '');
  }

  if (uri.includes('/da')) {
    return uri.replace('/da', '/en').replace(window.location.search, '');
  }

  return `${window.location.protocol}//${window.location.host}/en${window.location.pathname}`;
};

const ProfileWidgetComponent: FC = memo(() => {
  const lang = useLangContext();
  const [ctcSet, setCtcSet] = useState<boolean>(false);
  const copyAuIdRef = useRef<HTMLButtonElement>(null);
  const translations = useTranslationsContext();
  const userContext = useUserContext();
  const { auId, name } = userContext || {};

  useEffect(() => {
    if (auId && auId > 0 && !ctcSet) {
      if (copyAuIdRef) {
        setCopyToClipboard(copyAuIdRef.current as HTMLElement);
      }
      setCtcSet(true);
    }
  }, [ctcSet]);

  return (
    <div className="sub-nav__content theme--normal" aria-labelledby="profile-menu-toggle">
      <div className="sub-nav__user">
        <h2 className="sub-nav__user-name">{name}</h2>
        <button
          ref={copyAuIdRef}
          type="button"
          className="copy-to-clipboard"
          aria-label={`${translations.generics.user.au_id}: AU${auId}`}
          data-gtm="au-btn-header-copy-auid"
        >
          {`${translations.generics.user.au_id}: `}
          <span className="copy-to-clipboard__this">{`AU${auId}`}</span>
          <span className="copy-to-clipboard__hint" aria-hidden="true">{translations.generics.user.copy_auid}</span>
        </button>
      </div>
      <hr />
      <a
        className="sub-nav__item"
        href={`https://adgang.au.dk/${lang}/password/forgot`}
      >
        {translations.generics.sub_nav.change_password}
      </a>
      <a className="sub-nav__item sub-nav__item--icon" href={getOppositeLangUri()} data-icon="" data-gtm="au-btn-header-profile-changelanguage">{translations.generics.sub_nav.change_language}</a>
      <hr />
      <a
        className="sub-nav__item sub-nav__item--icon"
        href="/auth/logout"
      >
        {translations.generics.authentication.sign_out}
      </a>
    </div>
  );
});

ProfileWidgetComponent.displayName = 'ProfileWidgetComponent';
export default ProfileWidgetComponent;
